<template>
  <div>
    <div
      class="tree-node"
      :class="{
        expanded: expandedNodes[node.key],
        active: selectedNode?.key === node.key,
      }"
      @mouseenter="emit('hover', node)"
    >
      <!-- Icon -->
      <i :class="iconClass(node, level)"></i>

      <!-- Label (click selects the node) -->
      <span
        class="node-label"
        @click.stop="emit('select', node)"
        v-html="highlightedLabel(node.label)"
      ></span>

      <!-- Caret (click toggles expansion) -->
      <i
        class="fas fa-chevron-down arrow"
        :style="{
          visibility: node.children && node.children.length > 0 ? 'visible' : 'hidden',
        }"
        @click.stop="
          node.children && node.children.length > 0 ? emit('toggle', node.key) : null
        "
      ></i>
    </div>

    <!-- Children -->
    <div class="tree-children" v-if="node.children && expandedNodes[node.key]">
      <TreeNode
        v-for="child in node.children"
        :key="child.key"
        :node="child"
        :expandedNodes="expandedNodes"
        :selectedNode="selectedNode"
        :level="level + 1"
        :searchTerm="searchTerm"
        @toggle="emit('toggle', $event)"
        @hover="emit('hover', $event)"
        @select="emit('select', $event)"
      />
    </div>
  </div>
</template>

<script setup>
const props = defineProps({
  node: Object,
  expandedNodes: Object,
  selectedNode: Object,
  level: {
    type: Number,
    default: 0,
  },
  searchTerm: String,
});

const emit = defineEmits(["toggle", "hover", "select"]);

//icon by level
function iconClass(node, level) {
  if (node.icon) return node.icon;
  if (level === 0) return "fas fa-building";
  if (level === 1) return "fas fa-code-branch";
  if (level === 2) return "fas fa-sitemap";
  if (level === 3) return "fas fa-users";
  return "fas fa-user";
}
function highlightedLabel(label) {
  if (!props.searchTerm) return label;
  const term = props.searchTerm.replace(/[.*+?^${}()|[\]\\]/g, "\\$&");
  const regex = new RegExp(`(${term})`, "gi");
  return label.replace(regex, "<mark>$1</mark>");
}
</script>
